import React, { useState } from 'react'
import {
  styled,
  Box,
  Drawer,
  Divider,
  List,
  IconButton,
  ListItem,
  Typography,
  ListItemButton
} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu';
import { Link as ScrollLink} from 'react-scroll';
// import Close from '../assets/close.png';
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate, useLocation } from 'react-router-dom';

const drawerWidth = 240;
const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 5),
  ...theme.mixins.toolbar,
  justifyContent: 'flex-start',
}));


const itemList1 = [
  {
    text: 'Home',
    to: 'Home', // replace with the ID of the target component
  },
  {
    text: 'About',
    to: 'Features', // replace with the ID of the target component
  },
  {
    text: 'Features',
    to: 'AboutMindverse', // replace with the ID of the target component
  },
  {
    text: 'Why',
    to: 'Services', // replace with the ID of the target component
  },
  {
    text: 'How',
    to: 'HowItWorks', // replace with the ID of the target component
  },
];

//rotas
const itemList = [
  {
    text: 'Home',
    to: 'Home', // replace with the ID of the target component
  },
  
  {
    text: 'Why',
    to: 'Services', // replace with the ID of the target component
  },

  {
    text: 'About',
    to: 'Features', // replace with the ID of the target component
  },
 
  {
    text: 'When to Skoob',
    to: 'WhenToSkoob', // replace with the ID of the target component
  },

  {
    text: 'Skoob Curator Program',
    to: 'CuratorProgram', // replace with the ID of the target component
  },
];


const DrawerItem = () => {

  const navigate = useNavigate();
  const location = useLocation();
  

  const [open, setOpen] = useState(false);
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleClick = (item) => {
    const isCurator = item.to === 'CuratorProgram';

    if (isCurator) {
      navigate('/curator-program');
      setTimeout(() => {
        document
          .getElementById(item.to)
          ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    } else {
      if (location.pathname !== '/') {
        // Redirect to home and wait for scroll
        navigate('/');

        // Delay scroll until after route change
        setTimeout(() => {
          document
            .getElementById(item.to)
            ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
      // If already on '/', let ScrollLink handle it
    }
  };

  return (
    <Box >
      <IconButton
        color="inherit"
        aria-label="open drawer"
        edge="end"
        onClick={handleDrawerOpen}
        sx={{ ...(open && { display: 'none' }) }}
      >
        <MenuIcon />
      </IconButton>

      <Drawer
        sx={{
          flexGrow: 1,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            backgroundColor: '#181819;'
          },
        }}
        // variant="persistent"
        anchor="right"
        open={open}
      >
        <DrawerHeader >
          <CloseIcon onClick={handleDrawerClose} style={{cursor:'pointer',color:'white'}} />
        </DrawerHeader>
        <Divider />
        <List>
          {itemList.map((item) => {
            const { text, to } = item;
            return (
              <ListItem key={text} >
            {to === 'CuratorProgram' || location.pathname !== '/' ? (
              // Use button with custom onClick when redirecting
              <ListItemButton
                onClick={() => handleClick(item)}
                sx={{
                  color: '#fff',
                  fontSize: 18,
                  '&:hover': {
                    color: '#B9ACEA',
                    backgroundColor: '#463D7C',
                    borderRadius: 1,
                  },
                }}
              >
                <Typography
                  sx={{
                    fontFamily: 'Open Sans',
                    fontWeight: 400,
                    fontSize: 15,
                    width: 200,
                  }}
                >
                  {text}
                </Typography>
              </ListItemButton>
            ) : (
              // Use react-scroll link when already on '/'
              <ScrollLink
                to={to}
                spy={true}
                smooth={true}
                duration={500}
                offset={-200}
                activeClass="active"
              >
                <ListItemButton
                  sx={{
                    color: '#fff',
                    fontSize: 18,
                    '&:hover': {
                      color: '#B9ACEA',
                      backgroundColor: '#463D7C',
                      borderRadius: 1,
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: 'Open Sans',
                      fontWeight: 400,
                      fontSize: 15,
                      width: 160,
                    }}
                  >
                    {text}
                  </Typography>
                </ListItemButton>
              </ScrollLink>
            )}
          </ListItem>
            );
          })}
        </List>
      </Drawer>
    </Box>
  )
}

export default DrawerItem;